import { getPermissions } from 'helpers/permissions';
import React from 'react';
import { useSelector } from 'react-redux';
import { apiGet, apiPatch } from 'services';
import { ReviewState } from 'views/user/appraisals';
import Wizard from 'views/user/appraisals/components/wizard';
import posthog from 'posthog-js';
import { setShowSuccess } from 'actions/ui';
import { Loading, SystemText } from 'e4shared';
import { translateAppraisalJson } from 'helpers/translations';

export const ReviewDetails = ({ review, reload }) => {
    const [current, setCurrent] = React.useState({});
    const [congrats, setCongrats] = React.useState(false);
    const [inReview, setInReview] = React.useState(false);
    const [permissions, setPermissions] = React.useState(getPermissions());
    const [stage, setStage] = React.useState(-1);
    const [state, setState] = React.useState({});

    const { coaching, downline, user } = useSelector(state => state.user);

    React.useEffect(() => {
        setPermissions(getPermissions(user, user, coaching, downline));
    }, [user]);

    React.useEffect(() => {
        if (user?.id) {
            const tempState = ReviewState([review], review, user, user, false, review.submission);
            setState(tempState);
        }

        if (review.submission) {
            apiGet(`appraisal-json/${review.id}`, user.guid, json => {
                const temp = { ...review };
                temp.json = JSON.stringify(json);
                temp.competencies = json.competencies || [];
                translateAppraisalJson(user.language_Code, temp);
                setCurrent(temp);
            });
        } else {
            setCurrent(review);
        }
    }, [review, user?.id]);

    const api = {
        updateAppraisal: (app, completed) => {
            const temp = { ...current };

            if (state.user) {
                temp.user_Predictions = app.user_Predictions;
                temp.user_Competency_Comments = app.user_Competency_Comments;
                temp.user_Comments = app.user_Comments;
                temp.user_Comments_Done = app.user_Comments_Done;
            } else {
                temp.manager_Predictions = app.manager_Predictions;
                temp.manager_Competency_Comments = app.manager_Competency_Comments;
                temp.manager_Comments = app.manager_Comments;
                temp.manager_Comments_Done = app.manager_Comments_Done;
            }

            temp.goals = app.goals;

            setCurrent(temp);

            apiPatch(
                'appraisal-comment',
                app,
                user.guid,
                () => {
                    completed && setCongrats(true);
                },
                result => {
                    if (result.response.status === 409) {
                        history.replace('/develop/reviews/'); // load the main reviews page an let the standard logic take over
                    }
                }
            );
        },
        finaliseAppraisal: (app, callback) => {
            apiPatch(`appraisal-finalise`, app, user.guid, () => {
                posthog.capture('capability-review-completion');
                dispatch(setShowSuccess(SystemText('Reviews/Appraisals/Finalise/Success')));
                reload?.();
                callback?.();
            });
        },
    };

    const finalise = (appraisal, callback) => {
        const manager = current.manager_Predictions ? JSON.parse(current.manager_Predictions) : [];
        const staff = current.user_Predictions ? JSON.parse(v.user_Predictions) : [];

        const competencies = appraisal.competencies.map(c => ({
            ...c,
            manager: manager.find(x => x.competency_Id === c.id)?.level,
            staff: staff.find(x => x.competency_Id === c.id)?.level,
        }));

        appraisal.json = confirm
            ? JSON.stringify({ language_Id: user.language_Id, appraisal, competencies, profile: user })
            : undefined;

        api.finaliseAppraisal(appraisal, callback);
    };

    const setAgreedRatingValue = (id, level) => {
        const ratings = JSON.parse(current.ratings || '[]');
        const rating = ratings.find(r => r.id === id);
        if (rating) {
            rating.level = level;
        } else {
            ratings.push({ id, level });
        }

        const app = { ...current, ratings: JSON.stringify(ratings) };
        apiPatch(`appraisal-ratings`, app, user.guid, () => {
            setCurrent(app);
        });
    };

    if (!current?.id) return <Loading />;

    return (
        <div>
            <Wizard
                appraisal={current}
                congrats={congrats}
                finalise={finalise}
                finalising={state.finalStarted && !state.past}
                inReview={inReview}
                permissions={permissions}
                profile={user}
                setAgreedRatingValue={setAgreedRatingValue}
                setCongrats={setCongrats}
                setInReview={setInReview}
                setStage={s => {
                    setStage(s);
                    setCongrats(false);
                }}
                showBothManagerAndStaffRatingInfo={(state.finalStarted || state.past) && current?.participants === 'UM'}
                stage={stage}
                state={state}
                updateAppraisal={api.updateAppraisal}
                usePrismSummary
            />
        </div>
    );
};

export default ReviewDetails;
